import { useState, useEffect } from "react";
import axios from "axios";
import {
  HoldingsInformation,
  ResourceDWR,
} from "../../../dto/SuggestionResult";

export interface ItemAvailability {
	resourceId: number;
	itemIdentifier: string;
	available: boolean;
	status: string;
	dueDate: any; // TODO: type
	dueDateString: string;
	statusCode: string;
	modStatus: any; // TODO: type
	nonCirculating: boolean;
	onOrder: boolean;
}

export interface HostSystemDiag {
	hostSystemFailure: any;
	methodSupported: boolean;
	validHostUser: boolean;
	validSessionUser: boolean
}

export interface ItemAvailabilityReturn {
	hostSystemDiag: HostSystemDiag;
	itemAvailabilities: ItemAvailability[];
}

export const useItemAvailability = (
  holdings: HoldingsInformation[],
  resource: ResourceDWR
) => {
  const [itemAvailability, setItemAvailability] = useState<
    Map<HoldingsInformation["barcode"], ItemAvailability>
  >(new Map());
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    const currentTimestamp = new Date().getTime();
    const params = holdings.map(({ barcode }) => ({
      itemIdentifier: barcode,
      resourceId: resource.id,
    }));

    // TODO implement caching/debounce
    axios
      .post<ItemAvailabilityReturn>(`/availability?_=${currentTimestamp}`, params)
      .then(({ data }) => {
        setItemAvailability(
          data.itemAvailabilities.reduce((acc, availability) => {
            acc.set(availability.itemIdentifier, availability);
            return acc;
          }, new Map() as Map<ItemAvailability["itemIdentifier"], ItemAvailability>)
        );
        setReady(true);
      })
      .catch((err: Error) => {
        console.error(err);
      });
  }, [holdings, resource]);

  return { itemAvailability, ready };
};
